import { useParams, Link } from "react-router-dom";
import { useEffect, useState } from "react";
import { Check, ClipboardCopy, Copy, MapPin } from "lucide-react";
import MainHeader from "../components/MainHeader";
import Footer from "../components/Footer";
import promotion2 from "../components/assets/easter_desktop.webp";
import promotion_mobile from "../components/assets/easter_mobile1.webp";
import PanelVanOffer from "../components/assets/panelvan_offer_desktop.png";
import Spring_banner from "../components/assets/Spring_Special_Banner.webp";
import { toast ,Toaster } from "react-hot-toast";

const promos = [
  {
    slug: "Special-Offer",
    title: "Enjoy 10% Off On Next Rental",
    label: "Limited Time Offer",
    description: [
      "Offer applies on 2 day or more rentals.",
    ],
    code: "DRIVE10",
    validUntil: "June 6th, 2025",
    countries: ["United States", "Canada"],
    desktopImage: Spring_banner,
    mobileImage: Spring_banner,
    terms: [
      <>
        The 10% discount applies to the total charges of the rental.
      </>,
      <>
        Use the promo code{" "}
        <span className="text-black font-bold text">DRIVE10</span> to claim
        this offer. Offer is available at participating locations in the U.S. and Canada.
      </>,
      <>
        Offer may not be used in conjunction with any other promo code,
        promotion, or offer.
      </>,
      <>Minimum rental period is <strong>2 days or more</strong>. Valid until <strong>June 6th, 2025.</strong></>,
      <>Discount valid on rentals checked out no later than <strong>June 30th, 2025</strong>.</>,
      <>
        Offer is subject to vehicle availability and may not be available on
        select online rates at{" "}
        <a
          href="https://www.routes.ca"
          target="_blank"
          rel="noopener noreferrer"
          className="text-[#001dab] underline"
        >
          routes.ca
        </a>
        .
      </>,
      <>Car rental return restrictions may apply.</>,
      <>Offers are subject to change without notice.</>,
      <>Long weekend/holidays and other blackout periods may apply.</>,
      <>Renter must meet Routes age, driver, and credit card requirements.</>,
      <>
        Additional restrictions may apply. Refer to rental policy at checkout.
      </>,
    ],
  },
  {
    slug: "truck-and-van-deals",
    title: "Enjoy a 15% Discount.",
    label: "Truck and Van Deals",
    description: [
      <>Offer is available for <strong>Toronto, Calgary, Ottawa and Montreal </strong> locations only.</>,
    ],
    code: "MOVE15",
    validUntil: "June 15th, 2025",
    countries: ["Toronto", "Calgary", "Ottawa", "Montreal"],
    desktopImage: PanelVanOffer,
    mobileImage: PanelVanOffer,
    terms: [
      <>
        Offer is available for <strong>Toronto, Calgary, Ottawa and Montreal</strong> locations
        only.
      </>,
      <>
        Use the promo code{" "}
        <span className="text-black font-bold text">MOVE15</span> to claim this
        offer.
      </>,
      <>
        Offer may not be used in conjunction with any other promo code,
        promotion, or offer.
      </>,
      <>Discount valid on rentals checked out no later than <strong>June 30, 2025</strong>.</>,
      <>
        Offer is subject to vehicle availability and may not be available on
        select online rates at{" "}
        <a
          href="https://www.routes.ca"
          target="_blank"
          rel="noopener noreferrer"
          className="text-[#001dab] underline"
        >
          routes.ca
        </a>
        .
      </>,
      <>Car rental return restrictions may apply.</>,
      <>Offers are subject to change without notice.</>,
      <>Long weekend/holidays and other blackout periods may apply.</>,
      <>Renter must meet Routes age, driver, and credit card requirements.</>,
      <>Renter must meet our guidelines policy.</>,
      <>
        Additional restrictions may apply, refer to rental policy page for more
        information. you will find the rental policy page at the checkout.
      </>,
    ],
  },
  
];

const PromoDetails = () => {
  const { promoSlug } = useParams();
  const [promo, setPromo] = useState(null);
  const [showTerms, setShowTerms] = useState(false);
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    const matchedPromo = promos.find((p) => p.slug === promoSlug);
    setPromo(matchedPromo);
  }, [promoSlug]);

  if (!promo) {
    return (
      <div className="p-10 text-center text-red-600 text-lg">
        Promo not found 😢
      </div>
    );
  }

  const handleCopy = () => {
    navigator.clipboard.writeText(promo.code);
    toast.success('Promo code copied!', {
      duration: 2000,
      icon: '📋',
    });
  };

  return (
    <div className="min-h-screen bg-gradient-to-b from-gray-50 to-gray-100">
      <MainHeader />

      <main className="container mx-auto px-4 py-12 max-w-7xl">
        {promo.slug === "fifa-club-world-cup-2025" && (
        <div className="mb-4">
          <h1 className="text-center text-3xl font-bold text-orange-600 mb-2">Affordable Car Rentals for <span className="text-[#011CA8]">FIFA Club World Cup Fans</span> with <span className="text-[#011CA8]">Routes Car Rental</span></h1>
          <span className="text-center text-gray-600 mb-2">Attending the FIFA Football Club World Cup and need a convenient ride? Routes Car Rental offers unbeatable deals across top U.S. cities including Orlando International Airport, Atlanta, FLL, Tampa International, Miami, New York, and New Jersey. Whether you're looking for economy cars, SUVs, Jeep Wranglers, compact, or intermediate vehicles, we've got you covered with low-cost options tailored for Soccer fans on the move. From cheap car hire in Miami and Orlando to reliable rental cars in Atlanta, Brooklyn, and beyond, Routes Car Rental ensures a smooth drive to every match. Book now and enjoy affordable, flexible rentals wherever the tournament takes you</span>
        </div>
        )}
      <Toaster position="top-center" />
        <div className="bg-white rounded-lg overflow-hidden shadow-lg">
          {/* Images */}
          <div className="h-auto overflow-hidden">
            <img
              src={promo.desktopImage}
              alt={promo.title}
              className="hidden lg:block w-full object-cover"
            />
            <img
              src={promo.mobileImage}
              alt={promo.title}
              className="lg:hidden w-full object-cover"
            />
          </div>

          {/* Promo Content */}
          <div className="p-6">
            <h2 className=" flex item-center text-center text-2xl font-bold text-orange-600 mb-2">
              {promo.title}
            </h2>
            {promo.description.map((text, idx) => (
              <p key={idx} className="text-gray-700 mb-2">
                {text}
              </p>
            ))}

            {/* Promo Code + Validity */}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-2 mb-2 mt-4">
              <div className="border border-orange-200 bg-orange-50 rounded-md p-3">
                <p className="text-gray-600 flex items-center gap-2 flex-wrap">
                  Use Code:{" "}
                  <span className="font-bold text-orange-600 flex items-center gap-1">
                    {promo.code}
                    <button
                      onClick={handleCopy}
                      className="border-orange-300  px-2 py-1 text-orange-600 hover:bg-orange-100 transition"
                      title="Copy Code"
                    >
                      {copied ? <Check size={14} /> : <Copy size={14} />}
                    </button>
                  </span>
                </p>
              </div>
              <div className="border border-orange-200 bg-orange-50 rounded-md p-3">
                <p className="text-gray-600">
                  Valid Until :{" "}
                  <span className="font-bold text-orange-600">
                    {promo.validUntil}
                  </span>
                </p>
              </div>
            </div>

            {/* Locations */}
            <div className="flex flex-wrap items-center mb-4 gap-4">
              {promo.countries.map((country, idx) => (
                <div key={idx} className="flex items-center">
                  <MapPin className="text-orange-600 mr-2" size={20} />
                  <span className="text-gray-700 font-bold">{country}</span>
                </div>
              ))}
            </div>

            {/* Buttons */}
            <div className="space-y-3">
              <Link to="/" className="block">
                <button className="w-full bg-[#002B5C] text-white py-3 rounded-xl hover:bg-[#001F47] transition-all duration-300 shadow-md hover:shadow-lg">
                  Book Now
                </button>
              </Link>
              <button
                onClick={() => setShowTerms(!showTerms)}
                className="w-full text-orange-600 hover:text-orange-700 underline font-medium py-2"
              >
                {showTerms
                  ? "Hide Terms & Conditions"
                  : "View Terms and Conditions"}
              </button>
            </div>

            {/* Terms & Conditions */}
            {showTerms && (
              <div className="mt-4  p-4 rounded-xl">
                <h3 className="font-semibold text-orange-600 mb-3">
                  {promo.title}
                </h3>
                <div className="space-y-2 text-sm text-gray-700">
                  {promo.terms.map((term, idx) => (
                    <div
                      key={idx}
                      className="flex items-start gap-2 text-sm text-gray-700"
                    >
                      <span className="text-orange-500 mt-1">•</span>
                      <p>{term}</p>
                    </div>
                  ))}
                </div>
              </div>
            )}
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default PromoDetails;
